import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import { Form } from "react-bootstrap";
import "Components/SbSbProficiencyDrawer/SbSbProficiencyDrawer.scss";

import { safetyCheck } from "Api/apiService";

const SbSbProficiencyDrawer = ({
  isDrawerOpen,
  toggleDrawer,
  skillLevel,
  accessToken,
  requiredSkillLevel,
}) => {
  const [expectationNumber, setExpectationNumber] = useState(skillLevel);
  const [viewReset, setViewReset] = useState(false);
  const [viewSave, setViewSave] = useState(false);
  const [viewSubmit, setViewSubmit] = useState(false);

  const [safetyScanning, setsafetyScanning] = useState(false);
  const [documentType, setDocumnentType] = useState("");

  const dropdownOptions = [
    "Done a learning course(upload certificate)",
    "Delivered a Speech(upload certificate, audio or video)",
    "Held a job position(upload hiring letter)",
    "Any Other(Please specify)",
  ];

  // State variables for form data
  const [fileName, setFileName] = useState("");
  const [safetyCheckPassedFile, setSafetyCheckPassedFile] = useState(null);
  const [file, setFile] = useState(null);

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [expectedProficiencyReason, setxEpectedProficiencyReason] =
    useState("");

  const incrementExpectation = () => {
    if (expectationNumber < 5) {
      setExpectationNumber(expectationNumber + 1);
    }
  };

  const decrementExpectation = () => {
    if (expectationNumber > 0) {
      setExpectationNumber(expectationNumber - 1);
    }
  };

  // Handle file change
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
      setsafetyScanning(true);
      setSafetyCheckPassedFile(null);
      dataSafetyCheck(selectedFile);
    }
  };

  // Function to check data safety
  const dataSafetyCheck = async (
    selectedFile = null,
    enteredRoleContext = "",
    enteredBusinessContext = ""
  ) => {
    setError(""); // Reset error before each fetch

    if (selectedFile !== null) {
      setsafetyScanning(true);
    }
    if (
      enteredRoleContext === "" &&
      enteredBusinessContext === "" &&
      selectedFile === null
    ) {
      return false;
    }

    if (
      (enteredRoleContext !== "" || enteredBusinessContext !== "") &&
      selectedFile === null
    ) {
      setLoading(true);
    }

    let passedValue = "";

    const formData = new FormData();

    if (selectedFile !== null) {
      formData.append("file", selectedFile);
      passedValue = "file";
      setSafetyCheckPassedFile(false);
    }

    try {
      const safetyCheckResponse = await safetyCheck(formData, accessToken);
      if (safetyCheckResponse && safetyCheckResponse.is_safe === true) {
        setsafetyScanning(false);
        setLoading(false);
        if (passedValue == "file") {
          setSafetyCheckPassedFile(true);
        }
        return true;
      } else {
        setsafetyScanning(false);
        setLoading(false);
        if (passedValue == "file") {
          setSafetyCheckPassedFile(false);
        }
        return false;
      }
    } catch (error) {
      console.error("Error validating safety check:", error);
      setsafetyScanning(false);
      setLoading(false);
      if (passedValue == "file") {
        setSafetyCheckPassedFile(false);
      }
      setError("Could not run safety checks. Please retry.");
      return false;
    }
  };

  return (
    <div>
      {/* Overlay that darkens the background */}
      {isDrawerOpen && <div className="overlay" onClick={toggleDrawer}></div>}

      {/* Drawer that slides in from the right */}
      <div
        className={`drawer ${isDrawerOpen ? "open" : ""} proficiency-drawer`}
      >
        <div className="drawer-header bg-body-2">
          <div className="radio-buttons custom-tabs">
            <div className="tab-title">Change Proficiency</div>
          </div>

          <div onClick={toggleDrawer} title="Close">
            <svg
              width="24"
              height="28"
              viewBox="0 0 24 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6.85693L6 20.5712"
                stroke="#2F3437"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M6 6.85693L18 20.5712"
                stroke="#2F3437"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        <div className="drawer-body">
          <div className="attention-info d-flex flex-row gap-2 align-items-center">
            <svg
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 13H11V7H13V13ZM13 17H11V15H13V17ZM12 2C10.6868 2 9.38642 2.25866 8.17317 2.7612C6.95991 3.26375 5.85752 4.00035 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C5.85752 19.9997 6.95991 20.7362 8.17317 21.2388C9.38642 21.7413 10.6868 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2Z"
                fill="#6B7280"
              />
            </svg>
            <p>
              If you believe that the inferred proficiency is incorrect, tell us
              what your current proficiency should be. Upload evidence below if
              it's more than +/- 1 v/s inferred proficiency.
            </p>
          </div>

          <Form onSubmit={() => console.log("Form submitted")}>
            <div className="inferred-progress-bar mt-4">
              <div className="text-uppercase">
                <h5>Inferred Proficiency{" "}<span className="text-muted">(0-5 Scale)</span></h5>
                
              </div>
              <div>
                <svg width="8" height="8" xmlns="http://www.w3.org/2000/svg">
                  <rect width="8" height="8" rx="2" ry="2" fill="#007bff" />
                </svg>
                <span className="text-muted p-2 small text-capitalize">
                  Current Proficiency
                </span>
                <svg width="8" height="8" xmlns="http://www.w3.org/2000/svg">
                  <rect width="8" height="8" rx="2" ry="2" fill="#70b0ff" />
                </svg>
                <span className="text-muted p-2 small text-capitalize">
                  Required Proficiency
                </span>
              </div>
              <div
                className="progress-bar-visual-wrapper mt-4"
                style={{ position: "relative", width: "100%" }}
              >
                {/* Triangle pointer */}
                <div
                  className="triangle-pointer"
                  style={{
                    left: `calc(${(expectationNumber / 5) * 100}% - 6px)`, // 10px is half triangle width
                  }}
                >
                  <svg>
                    <polygon points="0,6 6,0 12,6" fill="#101840" />
                  </svg>
                </div>

                <div
                  className="progress-bar-container flex-grow-1"
                  style={{ position: "relative" }}
                >
                  {/* Vertical dotted line marker */}
                  <div
                    className="vertical-dotted-line"
                    style={{
                      left: `calc(${(expectationNumber / 5) * 100}% - 1px)`, // 1px is half the line's width
                    }}
                  >
                    <svg width="2" height="100%">
                      <line
                        x1="1"
                        y1="0"
                        x2="1"
                        y2="100%"
                        stroke="#101840"
                        strokeWidth="2"
                        strokeDasharray="4,4"
                      />
                    </svg>
                  </div>

                  {/* Progress bars */}
                  <div
                    className="progress-bar-current"
                    style={{ width: `${(skillLevel / 5) * 100}%` }}
                  >
                    <span className="progress-label">{skillLevel}</span>
                  </div>
                  <div
                    className="progress-bar-required"
                    style={{ width: `${(requiredSkillLevel / 5) * 100}%` }}
                  >
                    <span className="progress-label">{requiredSkillLevel}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="expectation text-center mt-2">
              <h5 className="mb-2">Your Expectation</h5>
              <div className="d-flex flex-row justify-content-center align-items-center pb-4">
                <Button
                  variant="outline-secondary"
                  onClick={decrementExpectation}
                  className="border border-2"
                >
                  <h5>-</h5>
                </Button>
                <div className="border border-2 justify-content-center align-items-center p-2 px-5">
                  <h5>{expectationNumber}</h5>
                </div>
                <Button
                  variant="outline-secondary"
                  onClick={incrementExpectation}
                  className="border border-2"
                >
                  <h5>+</h5>
                </Button>
              </div>
            </div>

            {expectationNumber > skillLevel + 1 ||
            expectationNumber < skillLevel - 1 ? (
              <div className="upload-evidence mt-2 mb-4">
                <h5 className="mb-2">
                  Briefly mention reasons why you changed your skills
                  proficiency
                </h5>
                <textarea
                  placeholder={`1. \n2. \n3.`}
                  value={expectedProficiencyReason}
                  onChange={(e) => setxEpectedProficiencyReason(e.target.value)}
                  className="form-control"
                  rows={3}
                />

                <div className="d-flex flex-row mt-4 w-100">
                  <div className="w-100 me-5">
                    <h5 className="mb-2">Upload Evidence to validate proficiency.</h5>
                    {/* DocType Dropdown */}
                    <Form.Group
                      controlId="doctypeDropdown"
                      className="mb-4 w-100 me-3"
                    >
                      <Form.Label>Document Type</Form.Label>
                      <Form.Select
                        value={documentType}
                        onChange={(e) => setDocumnentType(e.target.value)}
                        className="custom-select-drawer"
                      >
                        <option value="">Select document type</option>
                        {dropdownOptions.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </div>

                  <div className="w-100 mb-4">
                    <h5 className="mb-2">Upload Documents</h5>
                    <p className="mb-2">Add your documents here</p>
                    <Form.Group
                      controlId="formFile"
                      className="upload-section w-100 me-3"
                    >
                      <div className="custom-file-upload">
                        <input
                          type="file"
                          accept=".pdf,.doc,.docx"
                          id="upload-file"
                          onChange={handleFileChange}
                        />
                        {safetyScanning ? (
                          <div className="d-flex justify-content-center align-items-center flex-column mb-3">
                            <span className="text-center mb-3">
                              Scanning file...
                            </span>
                            <div className="spinner-border" role="status">
                              <span className="sr-only"></span>
                            </div>
                          </div>
                        ) : (
                          <div className="file-upload-area">
                            <svg
                              width="36"
                              height="36"
                              viewBox="0 0 36 36"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M29.025 15.06C28.005 9.885 23.46 6 18 6C13.665 6 9.9 8.46 8.025 12.06C3.51 12.54 0 16.365 0 21C0 25.965 4.035 30 9 30H28.5C32.64 30 36 26.64 36 22.5C36 18.54 32.925 15.33 29.025 15.06ZM28.5 27H9C5.685 27 3 24.315 3 21C3 17.925 5.295 15.36 8.34 15.045L9.945 14.88L10.695 13.455C12.12 10.71 14.91 9 18 9C21.93 9 25.32 11.79 26.085 15.645L26.535 17.895L28.83 18.06C31.17 18.21 33 20.175 33 22.5C33 24.975 30.975 27 28.5 27ZM12 19.5H15.825V24H20.175V19.5H24L18 13.5L12 19.5Z"
                                fill="#008080"
                              />
                            </svg>
                            <p>
                              Drop or <span>Upload</span> an existing JD
                            </p>
                            <p className="file-info">
                              .pdf and .docx files up to 10MB accepted.
                            </p>
                          </div>
                        )}
                      </div>

                      {!safetyScanning && fileName && safetyCheckPassedFile ? (
                        <div className="success-message-box mt-3">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M0 8C0 12.42 3.58 16 8 16C12.42 16 16 12.42 16 8C16 3.58 12.42 0 8 0C3.58 0 0 3.58 0 8ZM11.29 5.29C11.47 5.11 11.72 5 12 5C12.55 5 13 5.45 13 6C13 6.28 12.89 6.53 12.71 6.71L7.71 11.71C7.53 11.89 7.28 12 7 12C6.72 12 6.47 11.89 6.29 11.71L3.29 8.71C3.11 8.53 3 8.28 3 8C3 7.45 3.45 7 4 7C4.28 7 4.53 7.11 4.71 7.29L7 9.59L11.29 5.29Z"
                              fill="#52BD94"
                            />
                          </svg>
                          <div className="success-message-holder">
                            <p className="success-message">Success</p>
                            <p className="success-message-text">
                              File Uploaded : {fileName}
                            </p>
                          </div>
                        </div>
                      ) : (
                        !safetyScanning &&
                        fileName &&
                        !safetyCheckPassedFile && (
                          <div className="error-message-box mt-3">
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M7.99989 0.00488281C3.58265 0.00488281 0.00488281 3.58265 0.00488281 7.99989C0.00488281 12.4171 3.58265 15.9949 7.99989 15.9949C12.4171 15.9949 15.9949 12.4171 15.9949 7.99989C15.9949 3.58265 12.4171 0.00488281 7.99989 0.00488281ZM7.00051 12.9968V10.998H8.99926V12.9968H7.00051ZM7.00051 3.00301V9.99864H8.99926V3.00301H7.00051Z"
                                fill="#D14343"
                              />
                            </svg>
                            <div className="error-message-holder">
                              <p className="error-message">Error</p>
                              <p className="error-message-text">
                                <a
                                  className="google-safety-link"
                                  href="https://safety.google/content-safety/"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Google Safety Check
                                </a>{" "}
                                Failed : {fileName} Replace file.
                              </p>
                            </div>
                          </div>
                        )
                      )}
                    </Form.Group>
                  </div>
                  
                </div>
                        { viewReset && <div className="info-message-box mb-2 auth-page-info-box">
                            <span>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M8 0C3.58 0 0 3.58 0 8C0 12.42 3.58 16 8 16C12.42 16 16 12.42 16 8C16 3.58 12.42 0 8 0ZM9 3V5H7V3H9ZM6 12V13H10V12H9V6H6V7H7V12H6Z" fill="#008080" />
                                </svg>
                            </span>
                            <div className="info-message-holder">
                                <p className="success-message">Changes reset!</p>
                            </div>

                        </div>}

                        { viewSave && <div className="info-message-box mb-2 auth-page-info-box">
                            <span>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M8 0C3.58 0 0 3.58 0 8C0 12.42 3.58 16 8 16C12.42 16 16 12.42 16 8C16 3.58 12.42 0 8 0ZM9 3V5H7V3H9ZM6 12V13H10V12H9V6H6V7H7V12H6Z" fill="#008080" />
                                </svg>
                            </span>
                            <div className="info-message-holder">
                                <p className="success-message">Changes saved!</p>
                            </div>

                        </div>}

                        { viewSubmit && <div className="info-message-box mb-2 auth-page-info-box">
                            <span>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M8 0C3.58 0 0 3.58 0 8C0 12.42 3.58 16 8 16C12.42 16 16 12.42 16 8C16 3.58 12.42 0 8 0ZM9 3V5H7V3H9ZM6 12V13H10V12H9V6H6V7H7V12H6Z" fill="#008080" />
                                </svg>
                            </span>
                            <div className="info-message-holder">
                                <p className="success-message">Changes submitted!</p>
                            </div>

                        </div>}
                  

                        <div className="info-message-box mb-2 auth-page-info-box">
                            <rect width="32" height="20" rx="2" ry="2" fill="#007bff" />
                        </div>

                <div className="drawer-footer">
                  <Button variant="outline" type="reset" title="Reset to default" onClick={() => {
  setViewReset(true);
  setTimeout(() => {
    setViewReset(false);
  }, 3000);
}}>
                    Reset
                  </Button>
                  <Button variant="outline" type="reset" title="Save for editing later" onClick={(event) => {
    setViewSave(true);
    setTimeout(() => {
    setViewSave(false);
  }, 3000); 
  }}>
                    Save
                  </Button>
                  <Button variant="primary" type="reset" title="Submit once final" onClick={() => {
    setViewSubmit(true);
    setTimeout(() => {
    setViewSubmit(false);
  }, 3000); 
  }}>
                    Submit
                  </Button>
                </div>
              </div>
            ) : null}
          </Form>
        </div>
      </div>
    </div>
  );
};

export default SbSbProficiencyDrawer;
